import { PDFDocument } from 'pdf-lib'

const readAsArrayBuffer = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsArrayBuffer(file)
  })

const loadImageElement = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file)
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = reject
    img.src = url
  })

// pdf-lib can only embed raw PNG/JPEG bytes — anything else (WebP, GIF,
// BMP) gets redrawn to a canvas and re-exported as JPEG first.
const toEmbeddablePngOrJpeg = async (file) => {
  if (file.type === 'image/png') {
    return { bytes: await readAsArrayBuffer(file), isPng: true }
  }
  if (file.type === 'image/jpeg') {
    return { bytes: await readAsArrayBuffer(file), isPng: false }
  }
  const img = await loadImageElement(file)
  const canvas = document.createElement('canvas')
  canvas.width = img.width
  canvas.height = img.height
  const ctx = canvas.getContext('2d')
  ctx.fillStyle = '#ffffff'
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  ctx.drawImage(img, 0, 0)
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.92))
  return { bytes: await blob.arrayBuffer(), isPng: false }
}

export const imagesToPdf = async (files) => {
  const pdfDoc = await PDFDocument.create()

  for (const file of files) {
    const { bytes, isPng } = await toEmbeddablePngOrJpeg(file)
    const image = isPng ? await pdfDoc.embedPng(bytes) : await pdfDoc.embedJpg(bytes)
    const page = pdfDoc.addPage([image.width, image.height])
    page.drawImage(image, { x: 0, y: 0, width: image.width, height: image.height })
  }

  const pdfBytes = await pdfDoc.save()
  return new Blob([pdfBytes], { type: 'application/pdf' })
}
